<script setup>
import Account from "@/components/media/AccountList.vue";
import CDetail   from '@/components/media/CorpDetail.vue';
import Dialog   from '@/components/media/MediaDialog.vue';
import axios  from "axios";
axios.defaults.baseURL = 'https://qlipper.jp/';
axios.defaults.withCredentials = true;
axios.defaults.crossDomain = true;
</script>
<template>
<v-card
    flat
    tile
    width="95%"
>
    <CDetail ref="cd" v-on:mdsp="mdsp($event)"  />
    <Dialog  ref="md" 
        v-on:cdsp="cdsp($event)"
        v-on:snsdsp="snsdsp($event)"
    />
    <Account :site_id="result.site_id" ref="acc"  />
    <v-card-text class="px-0 py-0">
    <v-toolbar
        flat
    >
        <v-toolbar-title>
          <p style="margin:0" class="project-result-list__title"><a href="javascript:void(0)" v-on:click="media(result.site_id)" rel="noopener"><span v-html="result.site_name"></span></a> 
        <span class="rel_image_box">
            <img src="rel_image/fax.svg" class="rel_image" v-if="result.fax_no != null" alt="FAXで受付">
            <img src="rel_image/zip.svg" class="rel_image" v-if="result.zip_code != null" alt="郵送で受付">
            <img src="rel_image/mail.svg" class="rel_image" v-if="result.mail_address1 != null || result.mail_address2 != null || result.mail_address3 != null" alt="メールで受付">
            <img src="rel_image/site.svg" class="rel_image" v-if="result.relurl != null" alt="サイトで受付">
        </span>
        </p>
        </v-toolbar-title>
        <v-spacer>
        </v-spacer>
            <v-btn 
                class="mr-3"
                  v-if="result.fax_no != null || result.zip_code != null || result.mail_address1 != null || result.mail_address2 != null || result.mail_address3 != null || result.relurl != null"
                color="#E11D31"
                dark
                @click="medialist(result.site_id)"
            >
                <v-icon small>
                    mdi-plus
                </v-icon>
                リスト候補
            </v-btn>
            <v-switch
              v-model="imp_flg"
              label="重要指定"
              color="red"
              hide-details
              @change="setimp"
            ></v-switch>
    </v-toolbar>
    <div style="padding-top:0px!important" class="project-result-list__anchor" v-bind:style="[{'background-color': result.imp}]">
    <div class="media_list_box">
      <span class="project-result-list__url" v-cloak><a :href="result.site_url"  target="_blank" rel="noopener">{{ result.site_url }}</a></span>
      <div class="project-result-list__info">
        <ul class="result_media_summary">
            <li v-for="corps,index in disp_op_corp(result.op_ids,result.op_corp_names)" :key="index">
            <span class="corp_name" ><a  href="javascript:void(0)" v-on:click="corp(corps.id)">{{ corps.name }}</a></span>
            </li>
        </ul>
      </div>
        <div class="sns_account">
            SNS等アカウント:
            <span v-for="data,index in disp_account_data(result.account)" :key="index">
                <span v-if="index == 0" >公式アカウント</span>
                <span v-else-if="index == 1">代表（編集長）</span>
                <span v-else>編集者・ライター</span>
                <a href="javascript:void(0)" v-if="data != 0" v-on:click="accopen(result.site_id)"><span class="account_num">{{ data }}</span></a>
                <span class="account_num" v-else>{{ data }}</span>
            </span>
            <span v-if="result.mflg == 't'" style="vertical-align:bottom">
                <v-icon color="red" class="mr-2">mdi-email-alert</v-icon><span style="font-size:1.1rem;font-weight:bold;">メールアドレス有り</span>
            </span>
        </div>
     <div class="project-result-list__info" v-if="risk_flg == false">
           <div class="media_data_info">
                <v-card
                    flat
                    tile
                    style="background-color:transparent;"
                >
                <v-card-text
                    style="background-color:transparent;"
                    class="pt-0"
                >
                <v-row class="my-2">
                       <v-col class="py-0 px-0" cols="1"><span class="label">検知数</span></v-col>
                       <v-col class="py-0 px-0" v-if="result.publish_count != 0" >
                        <span class="media_num_text">{{  Number(result.count).toLocaleString()  }}</span>
                        記事
                    </v-col>
                    <v-col class="py-0 px-0" v-cloak v-else>-</v-col>
                    <v-col cols="6" class="py-0 px-0">
                           <span class="project-result-list__media-name" v-cloak>過去１ヶ月の仮想PV</span>
                           <span class="media_num_text" v-cloak v-if="result.page_view != 0">{{  Number(result.doc_view).toLocaleString()  }}&nbsp;pv</span><span class="project-result-list__date-text" v-cloak v-else>-</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="label px-0">サイトカテゴリ</v-col>
                    <v-col >{{ result.label }}</v-col>
                    <v-col class="label px-0" cols="3">月間総ページビュー</v-col>
                    <v-col >{{ Number(result.page_view).toLocaleString() }}pv</v-col>
                </v-row>
                <v-row >
                    <v-col class="label px-0">週間記事増加</v-col>
                    <v-col >{{ Number(result.doc_num).toLocaleString() }}記事</v-col>
                    <v-col class="label px-0" cols="3">週間引用ポスト数</v-col>
                    <v-col >{{ Number(result.tweet_num).toLocaleString() }}ポスト</v-col>
                </v-row>
                </v-card-text>
                </v-card>
              </div>
      </div>
     <!--div class="project-result-list__info">
          <div class="doc_summary_box">
            <h3>最新記事</h3>
              <span class="doc_title"><a :href="decodeURIComponent(result.doc_url)" target="_blank">{{ result.doc_title }}</a></span><span class="doc_date">{{ result.doc_date }}</span>
          </div>
      </div-->
      <div class="project-result-list__info" v-if="result.fax_no != null || result.zip_code != null || result.mail_address1 != null || result.mail_address2 != null || result.mail_address3 != null || result.relurl != null">
            <div class="rel_summary_box">
                <h3>プレスリリース受付窓口</h3>
                <v-list>
                    <v-list-item-title v-if="result.addressee != null">
                            <h2 style="margin:5px 10px">{{ result.addressee }}</h2>
                    </v-list-item-title>
                    <v-list-item v-if="result.fax_no != null && result.fax_no !=''">
                        <v-row>
                            <v-col cols="3">
                                <v-icon v-if="listexist(result.fax_no)" @click="listup(result,3,0)">mdi-plus</v-icon>
                                <v-icon v-else color="#71C076">mdi-check-circle-outline</v-icon>
                                FAX番号</v-col><v-col class="num">{{ result.fax_no }}</v-col>
                        </v-row>
                    </v-list-item>
                    <v-list-item v-if="result.address != null && result.address !=''">
                        <v-row>
                            <v-col cols="3">
                                <v-icon v-if="listexist(result.zip_code +' '+ result.address)" @click="listup(result,5,0)">mdi-plus</v-icon>
                                <v-icon v-else color="#71C076">mdi-check-circle-outline</v-icon>
                                住所</v-col><v-col class="num"><span v-if="result.zip_code != null" style="margin-right:5px">〒{{ result.zip_code }}</span>{{ result.address }}</v-col>
                        </v-row>
                    </v-list-item>
                    <v-list-item v-if="result.mail_address1 != null && result.mail_address1 != ''">
                        <v-row>
                            <v-col cols="3">
                                <v-icon v-if="listexist(result.mail_address1)" @click="listup(result,1,1)">mdi-plus</v-icon>
                                <v-icon v-else color="#71C076">mdi-check-circle-outline</v-icon>
                                メールアドレス</v-col><v-col cols="3">{{ result.mail_address1 }}</v-col><v-col>{{ result.mail_comment1 }}</v-col>
                        </v-row>
                    </v-list-item>
                    <v-list-item v-if="result.mail_address2 != null && result.mail_address2 !=''">
                        <v-row>
                            <v-col cols="3">
                                <v-icon v-if="listexist(result.mail_address2)" @click="listup(result,1,2)">mdi-plus</v-icon>
                                <v-icon v-else color="#71C076">mdi-check-circle-outline</v-icon>
                                メールアドレス</v-col><v-col cols="3">{{ result.mail_address2 }}</v-col><v-col>{{ result.mail_comment2 }}</v-col>
                        </v-row>
                    </v-list-item>
                    <v-list-item v-if="result.mail_address3 != null && result.mail_address3 != ''">
                        <v-row>
                            <v-col cols="3" >
                                <v-icon v-if="listexist(result.mail_address3)" @click="listup(result,1,3)">mdi-plus</v-icon>
                                <v-icon v-else color="#71C076">mdi-check-circle-outline</v-icon>
                                メールアドレス</v-col><v-col cols="3">{{ result.mail_address3 }}</v-col><v-col>{{ result.mail_comment3 }}</v-col>
                        </v-row>
                    </v-list-item>
                    <v-list-item v-if="result.relurl != null && result.relurl != ''">
                        <v-row>
                            <v-col cols="3">
                                <v-icon v-if="listexist(result.relurl)" @click="listup(result,2,0)">mdi-plus</v-icon>
                                <v-icon v-else color="#71C076">mdi-check-circle-outline</v-icon>
                                受付フォーム</v-col><v-col class="num"><a :href="result.relurl" target="_blank">{{ result.relurl }}</a></v-col>
                        </v-row>
                    </v-list-item>
                </v-list>
            </div>

      </div>
      <div class="project-result-list__info">
            <div class="tweet_summary_box">
                <img src="img/logo-black.png" class="media_tweet_icon" />
                <div class="project-result-list__tweetnum" v-cloak>ポスト【{{result.tweet_count}}】：RT【{{result.retweet_count}}】：いいね【{{result.tweet_favcount}}】：フォロワー【{{result.tweet_follower}}】</div>
                </div>
            </div>
      <ul class="project-result-tag-list">
       <li class="project-result-tag-list__item" v-for="tags,index in view_tag(result.icons)" :key="index">
        <span class="project-result-list__tag" v-cloak>{{ tags }}</span>
       </li>
      </ul>
     </div>
    </div>

    </v-card-text>
</v-card>
</template>
<script>
export default {
    props : ["result",],
    computed : {
        candlist : function(){
            return this.$store.getters["mediacand/get_candlist"];
        },
    },
    data : function(){
        return {
            risk_flg   : false, 
            imp_flg    : false,
        };
    },
    methods : {
        listup : async function(obj,contact_cd,list_no){
            let params = new URLSearchParams();
            params.append('site_id',obj.site_id);
            if(obj.addressee != null && obj.addressee != "")
                params.append('addressee',obj.addressee);
            params.append('contact_cd',contact_cd);
            let contact_item = "";
            switch(contact_cd)
            {
            case 1:
                if(list_no == 1)
                    contact_item = obj.mail_address1;
                else if(list_no == 2)
                    contact_item = obj.mail_address2;
                else if(list_no == 3)
                    contact_item = obj.mail_address3;
                break;
            case 2:
                contact_item = obj.relurl;
                break;
            case 3:
                contact_item = obj.fax_no;
                break;
            case 4:
                break;
            case 5:
                contact_item = obj.zip_code;
                if(contact_item != "")
                    contact_item += " ";
                contact_item += obj.address;
                break;
            default :
                break;
            }
            params.append('contact_item',contact_item);
            params.append('mode',1);
            await axios.post("/api/media/set_media_list",params)
            .then(response => {
                this.$store.commit("mediacand/set_candlist",response.data);
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        medialist : async function(site_id){
            let params = new URLSearchParams();
            params.append('site_id',site_id);
            params.append('mode',2);
            await axios.post("/api/media/set_media_list",params)
            .then(response => {
                this.$store.commit("mediacand/set_candlist",response.data);
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        mdsp : function(data){
            this.media(data.id);
        },
        media : function(site_id){
            this.$refs.md.mediaopen(site_id);
        },
        cdsp : function(data){
            this.corp(data.id);
        },
        corp : function(corp_id){
            this.$refs.cd.open(corp_id);
        },
        setimp : async function(){
            var params = new URLSearchParams();
            params.append('site_id', this.result.site_id);
            if(this.imp_flg == true)
                params.append('flg', true);
            else
                params.append('flg', false);
            await axios.post("/api/media/set_impmedia",params)
            .then(() => {
                this.$emit("refresh");
            }).catch((error) => {
                window.location.href = 'https://qlipper.jp/login';
                console.error('失敗です', error);
            });
        },
        listexist : function(data){
            for(let i=0;i < this.candlist.length ; i++)
            {
                if(this.candlist[i].contact_item == data)
                {
                    return false;
                }
            }
            return true;
        },
        view_tag: function(text) {
            if(text == null || text == '')
            {
                return null;
            }
            let tags = text.split(',');
            return tags;
        },
        disp_account_data : function (account_string){
            if (account_string === '')
            {
                return "";
            }
            let data = Array();
            data = account_string.toString().split(',');

            return data;
        },
        disp_op_corp : function (op_ids,op_names) {
            if (op_ids === '')
            {
                return "";
            }
            let data = Array();
            let ids = Array();
            let names = Array();
            if(op_ids != null)
                ids = op_ids.toString().split(',');
            if(op_names != null)
                 names = op_names.split(',');
            for(let i = 0 ; i < ids.length ; i++)
            {
                data.push({id:ids[i],name:names[i]});
            }
            return data;
        },
        snsdsp : function(data){
            this.accopen(data.id);
        },
        accopen(id){
            this.$refs.acc.open(id);
        },
    },
    created : function(){
        if(this.result.imp_id != null)
            this.imp_flg = true;
    },

}
</script>
